export default {
  "content": "<rect width=\"32\" height=\"32\" fill=\"#EBEBF0\" rx=\"16\"/><g clip-path=\"url(#a)\"><path fill=\"#3F4450\" d=\"M16 8a8 8 0 100 16 8 8 0 000-16zm2.447 8.895l-2 1a1.003 1.003 0 01-1.342-.448l-2-4a1.001 1.001 0 011.79-.894l1.553 3.105 1.105-.553a1 1 0 011.342.447 1.002 1.002 0 01-.448 1.343z\"/></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M8 8h16v16H8z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "32",
    "height": "32",
    "fill": "none"
  }
};